import React from "react";
import ShareButton from "../ShareButton.jsx";

const FacebookButton = ({ mediaShareURL, shareText, mediaType, gameData, sectionName, showLabel=false }) => {
  let utm = "";
  if (sectionName === "Action Replay") {
    utm = "utm_source=Stories&utm_medium=facebook_share&utm_campaign=action_replay";
  }

  const getIconSource = (sectionName) => {
    if (sectionName === "Full Story") {
      return "./img/facebookStoryLink.svg"; // Icon for sharing full story
    }
    return "./img/share_icon_circle_facebook.svg"; // Default white icon for others
  };

  const encodedUrl = encodeURIComponent(mediaShareURL);
  const encodedText = encodeURIComponent(shareText);
  const iconSource = getIconSource(sectionName);

  return (
    <ShareButton
      onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`)}
      source={iconSource}
      btnName="Facebook"
      mediaType={mediaType}
      gameData={gameData}
      sectionName={sectionName}
      btnLabel={showLabel ? "Facebook" : ""}
    />
  );
};

export default FacebookButton;
